import { Link } from "react-router-dom";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const NotFoundPage = () => {
  return (
    <>
      <SiteTitle title="صفحه مورد نظر یافت نشد" />

      <div className="card basic-data-table">
        <div className="card-body py-80 px-32 text-center">
          <img src="/assets/images/error-img.png" alt="" className="mb-24" />
          <h6 className="mb-16">صفحه مورد نظر یافت نشد</h6>
          <p className="text-secondary-light">
            به نظر می رسد که شما سعی دارید به صفحه ای دسترسی پیدا کنید که حذف
            شده و یا هرگز وجود نداشته
          </p>
          <Link to="/" className="btn btn-primary-600 radius-8 px-20 py-11">
            بازگشت به خانه
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
